/* eslint-disable no-useless-escape */
export const getBrowserName =()=>{
   var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    if (isSafari && iOS) {
      return "mob-ios-browser"
    } else if(isSafari) {
      return "mob-ios-browser"
    }else{
      return "mob-chrom-browser"
    }
}